import type { MemberType, Team as ITeam } from 'api/models';

/* This is a 'physical' class that is mapped to
 * the team table. We can have methods on it that
 * we could call on retrieved database objects.
 */
export class Team implements ITeam {
  teamId: number;

  teamName: string;

  teamType: MemberType;

  teamDescription?: string | undefined;

  roleId?: number | undefined;

  projectId?: number | undefined;

  projectIds?: number[];

  accountLevelTeam?: boolean;

  constructor(team: ITeam) {
    this.teamId = team.teamId;
    this.teamName = team.teamName;
    this.teamType = team.teamType;
    this.teamDescription = team.teamDescription;
    this.roleId = team.roleId;
    this.teamType = team.teamType;
    this.accountLevelTeam = team?.accountLevelTeam ?? false;
    this.projectIds = team?.projectIds ?? [];
  }
}
